import loading from '@/store/tools/loading';
import { Dispatch } from 'vuex';
import messageHandling from '@/store/tools/messageHandling';

export default {
	namespaced: true,
	modules: {
		loading,
		messageHandling,
	},
	actions: {
		async globalRefresh({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await Promise.all([
				dispatch('loading/changeLoadingStatus'),
				dispatch('loading/changeGlobalStatus'),
			]);
		},

		cleanAllTools({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('messageHandling/cleanMessages');
		},
	},
};
